import React from "react";
import Layout from "../components/layout";
import BlogHero from "../components/blog/BlogHero";
import BlogContent from "../components/blog/BlogContent";
import BlogHtmlContent from "../components/blog/BlogHtmlContent";
import Explore from "../components/blog/Explore";
import ContactUs from "../components/heroPoster/ContactUs";
import { SEO } from "../components/seo";

const BlogDetails: React.FC<any> = ({ pageContext }) => {
  const blog = pageContext?.blog?.attributes;
  return (
    <Layout
      footerData={pageContext?.common?.footerData}
      navbarData={pageContext?.common?.navbarData}
    >
      {/* <MaxWidthWrapper>
        <SecondaryWidthWrapper> */}
      <BlogHero
        title={blog?.title}
        bannerImage={blog?.bannerImage}
        publishedAt={blog?.publishedAt}
        readingTime={blog?.readingTime}
      />

      {blog?.html ? (
        <BlogHtmlContent html={blog?.html} />
      ) : (
        <BlogContent content={blog?.content ?? []} />
      )}

      <Explore
        blogs={pageContext?.blogsPostData}
        title="Related Articles & Resources"
        subtitle="Dive into a wealth of knowledge with our unique articles and resources. Stay informed about the latest trends and best practices in the tech industry."
      />

      <div id={"blogs-details-contact"}>
        <ContactUs
          title="Let's Make It Happen"
          titleGreen="Get Your Free Quote Today!"
        />
      </div>
      {/* </SecondaryWidthWrapper>
      </MaxWidthWrapper> */}
    </Layout>
  );
};

export default BlogDetails;

export const Head: React.FC<any> = ({ pageContext }) => {
  const blog = pageContext?.blog?.attributes;

  // Use dedicated SEO fields if available, fallback to content fields
  const seoTitle = blog?.seo?.metaTitle || blog?.title;
  const seoDescription = blog?.seo?.metaDescription || blog?.summary;
  const seoImage = blog?.seo?.metaImage?.media?.data?.[0]?.attributes?.url || blog?.bannerImage?.media?.data?.[0]?.attributes?.url;

  const fullImageUrl = seoImage
    ? `${process.env.GATSBY_BACKEND_URL || ''}${seoImage}`
    : '';

  // Combine keywords from different sources
  const allKeywords = [
    blog?.seo?.metaKeywords,
    blog?.metaKeywords,
    // Extract keywords from tags if available
    blog?.tags?.data?.length > 0 ? blog.tags.data.map((tag: any) => tag.attributes?.name || tag.name).join(', ') : null
  ].filter(Boolean).join(', ');

  return (
    <SEO
      title={seoTitle}
      description={seoDescription}
      keywords={allKeywords || blog?.metaKeywords}
      image={fullImageUrl}
      pathname={`/blogs/${blog?.slug}`}
      article={{
        publishedAt: blog?.publishedAt,
        updatedAt: blog?.updatedAt,
        category: blog?.category, // Pass full category object for proper handling
        tags: blog?.tags, // Pass full tags object for proper handling
        readingTime: blog?.readingTime
      }}
    >
      {/* Breadcrumb Schema for Blog Posts */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": process.env.GATSBY_SITE_URL || "https://cf-dev.propeliustech.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": `${process.env.GATSBY_SITE_URL || "https://cf-dev.propeliustech.com"}/blogs`
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": blog?.title,
              "item": `${process.env.GATSBY_SITE_URL || "https://cf-dev.propeliustech.com"}/blogs/${blog?.slug}`
            }
          ]
        })}
      </script>
    </SEO>
  );
};
